module.exports = __webpack_public_path__ + "img/d20190727_3.d0ea5309.jpg";